var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWidgetClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2792 43.8405C35.978 43.8405 43.8406 35.9779 43.8406 26.2791C43.8406 16.5802 35.978 8.71765 26.2792 8.71765C16.5803 8.71765 8.71777 16.5802 8.71777 26.2791C8.71777 35.9779 16.5803 43.8405 26.2792 43.8405Z",
    fill: "#37D2E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9178 33.6817L27.7013 29.3751C26.4442 28.6302 25.4199 26.8377 25.4199 25.3711V15.8267",
    stroke: "#733FD7",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65581 12.3116C4.74593 16.1992 3 21.0413 3 26.2791C3 39.1291 13.429 49.5581 26.2791 49.5581C39.1291 49.5581 49.5581 39.1291 49.5581 26.2791C49.5581 13.429 39.1291 3 26.2791 3C22.9502 3 19.7609 3.69837 16.8976 4.97872",
    stroke: "#37D2E9",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetClock);
export default __webpack_public_path__ + "static/media/WIDGET_CLOCK.d3495452a377904fed5767c56cb4c2ab.svg";
export { ForwardRef as ReactComponent };